import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { cancelSpoof } from 'actions/spoofing';
import { selectAccountFeature } from 'reducers/account/features';
import { NEW_NAV } from 'constants/features';

import { SpoofBanner } from 'next/components/Navigation';

// This component is a temporary bridge between the next SpoofBanner
// and the old redux store. Once the next redux store is in place
// This bridge will not longer be needed.
// This also controls that the banner does not appear for
// accounts that do not have the new nav bar yet.
const TemporarySpoofBanner = ({ accountId, hasNewNav, onCancel }) => {
  if (!hasNewNav) {
    return null;
  }

  return <SpoofBanner accountId={accountId} onCancel={onCancel} />;
};

TemporarySpoofBanner.propTypes = {
  accountId: PropTypes.string,
  onCancel: PropTypes.func,
};

const mapStateToProps = state => ({
  accountId: state.spoofing,
  hasNewNav: selectAccountFeature(state, NEW_NAV),
});

const mapDispatchToProps = {
  onCancel: cancelSpoof,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemporarySpoofBanner);
